import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

export const showMoreInfoTextSegmentConfig = {
    type: IBoosterTextSegmentType.BUTTON,
    text: "dowiedz się więcej"
};
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

export const showMoreInfoTextSegmentConfig = {
    type: IBoosterTextSegmentType.BUTTON,
    text: "dowiedz się więcej"
};
